import Tab from '../tab/Tab';
import styles from './Tabs.module.scss';
import { TabModel } from './useTabs';

interface TabsProps {
  tabs: TabModel[];
  activeTab?: number;
  onSelectTab: (index: number) => void;
  hasBorder?: boolean;
  size?: 'small' | 'medium';
}

export function Tabs({ tabs, activeTab, onSelectTab, hasBorder = false, size }: TabsProps) {
  return (
    <nav className={`${styles.tabs} ${hasBorder && styles['tabs--border']}`}>
      {tabs.map(({ title, isDotted }, i) => (
        <Tab
          key={title}
          title={title}
          active={activeTab === i}
          onClicked={() => onSelectTab(i)}
          isDotted={isDotted}
          size={size}
        />
      ))}
    </nav>
  );
}

export default Tabs;
